import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore"; // Veritabanı yazma fonksiyonları
import { auth, db } from "../firebase"; 
import { useNavigate } from "react-router-dom";

export default function Register() {
  // İsim bilgisini tutmak için state ekledik
  const [name, setName] = useState(""); 
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const nav = useNavigate();

  const register = async () => {
    // Boş alan kontrolü
    if (!name || !email || !password) {
        alert("Lütfen isim, e-posta ve şifre alanlarını doldurun.");
        return;
    }

    try {
      // 1. Kullanıcıyı oluştur (Authentication)
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // 2. Kullanıcının ismini veritabanına kaydet (Firestore)
      // "users" klasörünün içine, UID ismiyle bir belge açar ve içine ismini yazar.
      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        name: name,      // <-- İşte aradığınız isim buraya kaydediliyor!
        email: email,
        role: "student", // İsterseniz rol de ekleyebilirsiniz
        createdAt: new Date(),
        scores: {} 
      });

      console.log("Kayıt başarılı, veritabanına eklendi.");
      nav("/dashboard");
      
    } catch (e) {
      console.error("Kayıt hatası:", e);
      alert("Kayıt sırasında bir hata oluştu: " + e.message);
    }
  };

  return (
    <div style={{ padding: 20, display: "flex", flexDirection: "column", maxWidth: "300px", gap: "15px" }}>
      <h2>Kayıt Ol</h2>
      
      {/* İsim Giriş Kutusu */}
      <input 
        type="text" 
        placeholder="Ad Soyad Giriniz" 
        value={name} 
        onChange={e => setName(e.target.value)} 
        style={{ padding: "10px", fontSize: "16px" }}
      />

      <input 
        type="email"
        placeholder="E-posta" 
        value={email} 
        onChange={e => setEmail(e.target.value)} 
        style={{ padding: "10px", fontSize: "16px" }}
      />
      
      <input 
        type="password" 
        placeholder="Parola" 
        value={password} 
        onChange={e => setPassword(e.target.value)} 
        style={{ padding: "10px", fontSize: "16px" }}
      />
      
      <button onClick={register} style={{ padding: "12px", cursor: "pointer", backgroundColor: "#007bff", color: "white", border: "none", borderRadius: "5px" }}>
        Kayıt Ol
      </button>
    </div>
  );
}